import { isEqual } from 'lodash-es'
import { SECURESTATE } from '.'
import { SecureState } from '../../types/state'
import { pubSubSecureState } from './pubSub'

export const setSecureState = <T extends keyof SecureState>(
    key: T,
    secureState: SecureState[T],
    immediate = true,
) => {
    if (!key) throw new Error('[setSecureState] key is required')
    if (isEqual(SECURESTATE[key], secureState)) return
    SECURESTATE[key] = secureState
    pubSubSecureState.emit(key, secureState, immediate)
}

export const updateSecureState = <T extends keyof SecureState>(
    key: T,
    secureState: Partial<SecureState[T]> = {},
    immediate = true,
) => {
    if (!key) throw new Error('[updateSecureState] key is required')
    setSecureState(key, { ...SECURESTATE[key], ...secureState }, immediate)
}
